function formatPackageSearchHref(pageName, tripType, startLocation, endLocation, startDate, endDate, travelers, hotelStartDate, hotelEndDate, isPartialStay) {
    const params = {
        'redirect-source': pageName,
        'flight-code': 'RT',
        'trip-type': tripType,
        'origin-item': startLocation?.itemName,
        'origin-id': startLocation?.id,
        'origin-type': startLocation?.type,
        'origin-city': startLocation?.cityName,
        'origin-state': startLocation?.provinceName ?? void 0,
        'origin-state-code': startLocation?.stateCode ?? void 0,
        'origin-country': startLocation?.country,
        'origin-country-code': startLocation?.countryCode,
        'origin-latitude': startLocation?.lat,
        'origin-longitude': startLocation?.lon,
        'destination-item': endLocation?.itemName,
        'destination-id': endLocation?.id,
        'destination-type': endLocation?.type,
        'destination-city': endLocation?.cityName,
        'destination-state': endLocation?.provinceName ?? void 0,
        'destination-state-code': endLocation?.stateCode ?? void 0,
        'destination-country': endLocation?.country,
        'destination-country-code': endLocation?.countryCode,
        'destination-latitude': endLocation?.lat,
        'destination-longitude': endLocation?.lon,
        start: startDate,
        end: endDate,
        rooms: travelers?.rooms,
        adults: travelers?.adults,
        children: travelers?.children,
        ages: JSON.stringify(travelers?.childrenAges),
        ...isPartialStay ? {
            'hotel-start': hotelStartDate,
            'hotel-end': hotelEndDate
        } : {}
    };
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params))if (null != value) searchParams.set(key, String(value));
    return `/shop/search/trips/?${searchParams.toString()}`;
}
export { formatPackageSearchHref };
